import React, { FC } from "react";
import ElBgContainer from "components/containers/ElBgContainer/ElBgContainer";

type CardProps = {
  titleWhite: string;
  titleYellow: string;
  imgUrl: string;
  text: string;
};
const Card: FC<CardProps> = ({ titleWhite, titleYellow, imgUrl, text }) => {
  return (
    <ElBgContainer customClassNames="padding-h18 padding-v20 full-width">
      <h3 className="">
        {titleWhite} <span className="gradient-pink-text">{titleYellow}</span>
      </h3>
      <img src={imgUrl} alt="" />
      <p className="fLora t-align-l font-s16 font-w400 brownish-gray-text">
        {text}
      </p>
    </ElBgContainer>
  );
};

export default Card;
